import { useCollectionConditionally } from "ember";
import { where } from "firebase/firestore";
import { Certification, CertificationRecord } from "models"
import { useAuthData } from "stuff";
import * as React from 'react';


const ShowCertificationRecords =

({

    certification,
    setCloseDialog

} : {

    certification?: Certification,
    setCloseDialog: React.Dispatch<React.SetStateAction<boolean>>,

}) =>

{
    
    const { claims } = useAuthData();


    //handle better later will throw exceptions when empty
    const certification_records: any = useCollectionConditionally(
    (certification !== undefined),
    `${claims.organization_id}/certification_records`,
    where('certification._id', '==', certification?._id)
    )

    console.log({certification_records})

    

    return (

        <div>{certification_records}</div>
    )



}








export default ShowCertificationRecords


